/**
 * @file
 * _dropdown-hover.js
 *
 * Handles hovering of the Bootstrap 5 dropdowns.
 */
import Dropdown from 'bootstrap/js/dist/dropdown';

(function (Drupal, once) {
  "use strict";

  Drupal.behaviors.GimUemoaDropdownHover = {
    attach: function (context) {
      // Désactivation simple en mode admin
      if (window.location.pathname.includes('/admin')) {
        return;
      }

      const dropdowns = once(
        "dropdown-hover",
        ".header .dropdown",
        context
      );

      dropdowns.forEach(function (dropdown) {
        const dropdownToggle = dropdown.querySelector('[data-bs-toggle="dropdown"]');

        if (!dropdownToggle) {
          return;
        }

        let dropdownInstance;
        try {
          dropdownInstance = Dropdown.getOrCreateInstance(dropdownToggle);
        } catch (error) {
          console.error('Error creating dropdown instance:', error);
          return;
        }

        dropdown.addEventListener("mouseenter", function () {
          dropdownInstance.show();
        });

        dropdown.addEventListener("mouseleave", function (e) {
          const relatedTarget = e.relatedTarget;
          if (relatedTarget && dropdown.contains(relatedTarget)) {
            return;
          }

          dropdownInstance.hide();
        });

        const subDropdowns = dropdown.querySelectorAll('.dropdown-menu .dropdown');
        subDropdowns.forEach(function(subDropdown) {
          const subToggle = subDropdown.querySelector('[data-bs-toggle="dropdown"]');
          if (!subToggle) return;

          let subInstance;
          try {
            subInstance = Dropdown.getOrCreateInstance(subToggle);
          } catch (error) {
            return;
          }

          subDropdown.addEventListener("mouseenter", function () {
            subInstance.show();
          });

          subDropdown.addEventListener("mouseleave", function (e) {
            const relatedTarget = e.relatedTarget;
            if (relatedTarget && subDropdown.contains(relatedTarget)) {
              return;
            }
            subInstance.hide();
          });
        });
      });

    },
  };
})(Drupal, once);
